<template>
    <v-container fluid>
        <h1>방문신청 정보</h1>

        <template v-if="visitInfo">
            <v-row class="a10-apply-view">
                <v-col cols="12" md="6">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">신청인 정보</v-card-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문신청 ID</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitId }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>성명</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.agentName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>휴대폰</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.agentMobile | phone }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>소속 업체명</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.agentCompany }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12" md="6">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">방문 정보</v-card-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문목적</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.purpose }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문 일정</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.startDatetime | moment('YYYY-MM-DD A hh:mm') }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문 업체</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitCompanyName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>방문할 지역</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitAreaName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>접견자</v-list-item-title>
                                <v-list-item-subtitle>{{ visitInfo.visitDeptName }} {{ visitInfo.visitUserName }} {{ visitInfo.visitTitleName }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col cols="12" md="4">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">방문자 정보</v-card-title>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>상태</v-list-item-title>
                                <v-list-item-subtitle>
                                    <div v-if="!['APPROVED', 'REJECTED', 'CANCELED'].includes(visitor.visitStatus)">
                                        <v-chip
                                            v-if="visitor.educationDateTime"
                                            small
                                            color="blue"
                                            text-color="white"
                                        >
                                            교육이수완료
                                        </v-chip>
                                        <v-chip
                                            v-if="visitor.vip !== 'Y' && !visitor.educationDateTime"
                                            small
                                            color="yellow"
                                            text-color="black"
                                        >
                                            교육이수전
                                        </v-chip>
                                    </div>
                                    <div v-else>
                                        <v-chip small
                                                :color="getStatusInfo(visitor.visitStatus).backgroundColor"
                                                :text-color="getStatusInfo(visitor.visitStatus).color"
                                        >{{ getStatusInfo(visitor.visitStatus).text }}
                                        </v-chip>
                                        <div v-if="['REJECTED', 'CANCELED'].includes(visitor.visitStatus)">
                                        <span class="void-reason"
                                              @click="$window.alert(visitor.voidReason, 'info')">
                                            사유: {{ visitor.voidReason }}
                                        </span>
                                        </div>
                                    </div>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>성명</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip
                                        v-if="visitor.vip === 'Y'"
                                        x-small
                                        color="red"
                                        text-color="white"
                                        class="mr-1"
                                    >
                                        VIP
                                    </v-chip>
                                    {{ visitor.visitorName }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>휴대폰</v-list-item-title>
                                <v-list-item-subtitle>{{ visitor.visitorMobile }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>업체</v-list-item-title>
                                <v-list-item-subtitle>{{ visitor.visitorCompany }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>차량번호</v-list-item-title>
                                <v-list-item-subtitle>{{ visitor.visitorCarNumber || '-' }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>실제 방문시간</v-list-item-title>
                                <v-list-item-subtitle>{{ visitor.checkDateTime || '-' }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-col>
                <v-col v-if="isUseImportItem" cols="12" md="8">
                    <v-card class="pa-4 visit-info-card">
                        <v-card-title class="pa-0 mb-2">{{ visitor.visitorName }} 님의 반입물품 / 전자기기</v-card-title>
                        <v-data-table
                            :headers="carryInItemHeaders"
                            :items="importItems"
                            :items-per-page="-1"
                            item-key="importId"
                            :disable-sort="$vuetify.breakpoint.smAndDown"
                            no-data-text="반입 물품이 없습니다"
                            hide-default-footer
                        >
                            <template v-slot:item.reason="{ item }">
                                <span class="reason">{{ item.reason }}</span>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <template v-else>
            <v-card class="pa-4 visit-info-card">
                <v-card-text style="font-size: 1rem">방문예약 정보가 없습니다.</v-card-text>
            </v-card>
        </template>

        <v-card flat color="rgba(0,0,0,0)" class="a10-apply-view">
            <v-card-actions v-if="force" class="justify-center">
                <v-btn v-if="['WAITING', 'PENDING'].includes(visitor.visitStatus)"
                       @click="approveConfirm"
                       color="primary"
                >
                    승인
                </v-btn>
                <v-btn v-if="['WAITING', 'PENDING', 'APPROVED'].includes(visitor.visitStatus)"
                       @click="rejectConfirm"
                       class="ml-4"
                >
                    반려
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
import {mapState} from "vuex";
import ApplyActionMixin from "@/components/apply/ApplyActionMixin";
import ImportItemHelper from "@/service/importItemHelper";

export default {
    name: 'VisitInfo',
    mixins: [ ApplyActionMixin ],

    data: () => ({
        encryptedVisitId: null,
        encryptedVisitorId: null,
        visitInfo: null,
        visitor: null,
        importItems: [],
        force: false,

        carryInItemHeaders: [
            {text: '물품종류', value: 'importType'},
            {text: '제조사', value: 'manufacturer'},
            {text: '모델명', value: 'model'},
            {text: '시리얼번호', value: 'serial'},
            {text: '사유', value: 'reason', width: 200},
        ],
    }),

    computed: {
        ...mapState(['secretKey', 'iv']),
        fieldConfig() {
            return ImportItemHelper.parseImportItemColumnsConfig(this.$code.get('service.config.import_item_columns'))
        },
        isUseImportItem() {
            return this.$code.get('service.config.use_import_item') === 'Y';
        },
    },

    async created() {
        this.force = this.$route.params.force === 't';
        this.encryptedVisitId = this.$route.params.encryptedVisitId;
        this.encryptedVisitorId = this.$route.params.encryptedVisitorId;
        this.carryInItemHeaders = ImportItemHelper.cleanUnusedHeaders(this.carryInItemHeaders, this.fieldConfig);
        await this.fetchVisitorInfo()
    },

    methods: {
        async fetchVisitorInfo() {
            this.$window.showLoading("로딩 중...");

            try {
                const res = await this.$axios.post('/v1/home/visit/visitorInfo', {
                    visitId: this.encryptedVisitId,
                    visitorId: this.encryptedVisitorId
                });
                this.visitInfo = res.data.visitInfo;
                this.visitor = res.data.visitor;
                this.importItems = res.data.importItems;
            } catch(err) {
                this.$window.alert(err.message, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        /**
         * 방문 승인
         *
         */
        async approveConfirm() {
            const result = await this.$window.confirm('방문을 승인 하시겠습니까?');

            if (!result) {
                return;
            }

            this.$window.showLoading('승인 중...');

            try {
                await this.approve(this.visitInfo, this.visitor);
                this.$window.alert('승인 되었습니다.');
                await this.fetchVisitorInfo();
            } catch(err) {
                this.$window.alert(err.message ? err.message : err, 'error');
            } finally {
                this.$window.hideLoading();
            }
        },

        /**
         * 방문 반려
         *
         */
        async rejectConfirm() {
            const reason = await this.$window.prompt('반려 사유를 입력해주세요.', true, '반려 사유');
            if (!reason) {
                return;
            }

            this.$window.showLoading('반려 중...');

            try {
                await this.reject(this.visitInfo, this.visitor, reason);
                this.$window.alert('반려 되었습니다.');
                await this.fetchVisitorInfo();
            } catch(err) {
                this.$window.alert(err.message ? err.message : err, 'error');
            } finally {
                this.$window.hideLoading();
            }
        }
    },
}
</script>

<style>
.a10-apply-view .visit-info-card {
    height: 100%;
}
.a10-apply-view .v-list-item {
    padding: 0 8px;
}
.a10-apply-view .v-list-item__content {
    padding: 8px 0;
}
.a10-apply-view .v-list-item__title {
    font-size: 0.8rem;
    color: #707070;
    margin-bottom: 4px !important;
}
.a10-apply-view .v-list-item__subtitle {
    font-size: 1rem;
    color: #212121 !important;
}
.a10-apply-view .reason {
    display: block;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: inherit;
}
.a10-apply-view .void-reason {
    font-size: 0.8rem;
    color: #f44336;
}
</style>